module.exports = __webpack_public_path__ + "images/invite_participant_background.webp";